import * as React from 'react';

// My components
import Visualizer from '../../redux/containers/visualizer/Visualizer';

export default function Home(props) {
  return <Visualizer {...props} />;
}
